import { render, staticRenderFns } from "./MerkenCombo.vue?vue&type=template&id=0f9d3776&scoped=true"
import script from "./MerkenCombo.vue?vue&type=script&lang=js"
export * from "./MerkenCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9d3776",
  null
  
)

export default component.exports